import _objectWithoutProperties from '../../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.es.js';
import _taggedTemplateLiteral from '../../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, css } from '@mgmresorts/wcl-styled';
import React from 'react';
import '../../../../../node_modules/styled-system/dist/index.esm.es.js';
import { space } from '../../../../../node_modules/@styled-system/space/dist/index.esm.es.js';

var _excluded = ["height"];

var _templateObject, _templateObject2;

var getIconColorFromProps = function getIconColorFromProps(p) {
  if (p.color) {
    return p.theme.colors[p.color] || p.color;
  }

  return null;
};

var getIconHoverFromProps = function getIconHoverFromProps(p) {
  if (p.hoverColor) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      transition: color 0.25s;\n      &:hover {\n        color: ", ";\n        cursor: pointer;\n      }\n    "])), p.theme.colors[p.hoverColor] || p.hoverColor);
  }

  return null;
};

var StyledIconWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  display: inline-flex;\n  align-self: center;\n  color: ", ";\n  ", "\n"])), space, getIconColorFromProps, getIconHoverFromProps);
var createIcon = function createIcon(_ref) {
  var name = _ref.name,
      width = _ref.width,
      height = _ref.height,
      render = _ref.render;

  var WrappedIcon = function WrappedIcon(_ref2) {
    var _ref2$height = _ref2.height,
        wrapperHeight = _ref2$height === void 0 ? '1em' : _ref2$height,
        props = _objectWithoutProperties(_ref2, _excluded);

    var wrapperWidth;
    var icon;

    if (typeof wrapperHeight === 'string') {
      wrapperHeight = parseFloat(wrapperHeight);
      wrapperWidth = width * (wrapperHeight / height);
      icon = render({
        width: "".concat(wrapperWidth, "em"),
        height: "".concat(wrapperHeight, "em")
      });
    } else {
      wrapperWidth = width * (wrapperHeight / height);
      icon = render({
        width: wrapperWidth,
        height: wrapperHeight
      });
    }

    return /*#__PURE__*/React.createElement(StyledIconWrapper, Object.assign({}, props), /*#__PURE__*/React.cloneElement(icon, {
      focusable: false
    }));
  };

  WrappedIcon.displayName = "WrappedIcon(".concat(name, ")");

  WrappedIcon.selector = function (iconName) {
    return "WrappedIcon(".concat(iconName, ")");
  };

  return WrappedIcon;
};

export { StyledIconWrapper, createIcon };
